import React from 'react';
import { Printer } from 'lucide-react';

// Fitness / Spor Salonu — Türkiye Arama Mevsimselliği (statik rapor).
// Veri: Google Ads Keyword Planner (GOOGLE_SEARCH), TR geo 2792 · dil TR 1037,
// 48 ay geçmiş (2022-07→2026-06), takvim-ayı ortalaması → endeks (100 = yıl ort.).
// Glowytics kurumsal dili: tek-aksan indigo + nötr slate; her zaman açık tema.
// Renk kararı: mevsimsellik 100 etrafında sapan (diverging) → yüksek sezon indigo,
// düşük sezon nötr gri; iki küme (gym/diyet) için indigo + teal (CVD doğrulandı).

const CSS = `
.fs-deck {
  --accent:#4f46e5; --accent-strong:#4338ca; --accent-soft:#6d66ea;
  --teal:#0e9384; --pm-green:#2f8f80; --pm-red:#c65b6e; --pm-yellow:#b98a3e;
  --ink:#0f172a; --paper:#f4f7ff; --paper-2:#ffffff;
  --line:#e4e9f7; --muted:#5b647a; --muted-2:#94a0b8; --surface-2:#eef2fd;
  --bg:var(--paper); --surface:var(--paper-2); --text:var(--ink); --text-dim:var(--muted); --border:var(--line);
  --grid-max:1120px; --radius:14px;
  --shadow:0 1px 2px rgba(15,23,42,.05), 0 12px 34px -20px rgba(15,23,42,.28);
  --f-sans:-apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  --f-mono:ui-monospace,"SF Mono","Cascadia Mono",Menlo,Consolas,monospace;
  background:var(--bg); color:var(--text); font-family:var(--f-sans); line-height:1.55;
  -webkit-font-smoothing:antialiased; min-height:100vh;
}
.fs-deck * { box-sizing:border-box; }
.fs-deck .wrap { max-width:var(--grid-max); margin:0 auto; padding:0 clamp(20px,4vw,48px); }
.fs-deck .slide { padding:clamp(38px,6vh,72px) 0; border-bottom:1px solid var(--border); position:relative; }
.fs-deck .slide:last-of-type { border-bottom:none; }
.fs-deck .eyebrow { display:inline-flex; align-items:center; gap:.55em; font-size:.74rem; font-weight:700; letter-spacing:.16em; text-transform:uppercase; color:var(--text-dim); }
.fs-deck .eyebrow .dot { width:9px; height:9px; border-radius:50%; background:var(--accent); }
.fs-deck h1,.fs-deck h2,.fs-deck h3,.fs-deck h4 { text-wrap:balance; margin:0; line-height:1.08; letter-spacing:-.02em; }
.fs-deck h1 { font-size:clamp(2.1rem,5vw,3.8rem); font-weight:800; }
.fs-deck h2 { font-size:clamp(1.6rem,3.4vw,2.5rem); font-weight:800; }
.fs-deck h3 { font-size:clamp(1.05rem,1.7vw,1.35rem); font-weight:700; }
.fs-deck p { margin:0; }
.fs-deck .lead { font-size:clamp(1rem,1.4vw,1.2rem); color:var(--text-dim); line-height:1.5; max-width:66ch; }
.fs-deck .section-head { margin-bottom:clamp(22px,3.5vh,38px); }
.fs-deck .section-head h2 { margin-top:12px; }
.fs-deck .section-head .lead { margin-top:14px; }
.fs-deck .cover { border-bottom:none; }
.fs-deck .cover-top { display:flex; justify-content:space-between; align-items:center; gap:20px; flex-wrap:wrap; margin-bottom:clamp(28px,5vh,56px); }
.fs-deck .logo-lockup { display:flex; align-items:center; gap:14px; font-weight:800; font-size:1.02rem; }
.fs-deck .brick { display:inline-grid; grid-template-columns:repeat(3,10px); grid-auto-rows:10px; gap:3px; }
.fs-deck .brick i { border-radius:2px; display:block; }
.fs-deck .cover h1 .hl { color:var(--accent); }
.fs-deck .cover-sub { margin-top:22px; font-size:clamp(1.05rem,1.8vw,1.4rem); color:var(--text-dim); max-width:56ch; }
.fs-deck .cover-meta { margin-top:clamp(28px,5vh,52px); display:flex; flex-wrap:wrap; gap:14px 40px; padding-top:24px; border-top:2px solid var(--ink); }
.fs-deck .cover-meta div { display:flex; flex-direction:column; gap:3px; }
.fs-deck .cover-meta .k { font-size:.72rem; letter-spacing:.14em; text-transform:uppercase; color:var(--text-dim); font-weight:700; }
.fs-deck .cover-meta .v { font-size:1rem; font-weight:700; }
.fs-deck .rule { height:3px; border-radius:3px; margin-top:30px; background:linear-gradient(90deg,var(--accent),color-mix(in srgb,var(--accent) 22%,transparent) 62%,transparent); }
.fs-deck .grid { display:grid; gap:16px; }
.fs-deck .g2 { grid-template-columns:repeat(2,1fr); }
.fs-deck .g4 { grid-template-columns:repeat(4,1fr); }
@media (max-width:820px){ .fs-deck .g4 { grid-template-columns:repeat(2,1fr); } .fs-deck .g2 { grid-template-columns:1fr; } }
@media (max-width:520px){ .fs-deck .g4 { grid-template-columns:1fr; } }
.fs-deck .card { background:var(--surface); border:1px solid var(--border); border-radius:var(--radius); padding:20px; box-shadow:var(--shadow); }
.fs-deck .card .tag { font-size:.7rem; font-weight:700; letter-spacing:.12em; text-transform:uppercase; color:var(--text-dim); }
.fs-deck .topbar { height:4px; border-radius:4px 4px 0 0; margin:-20px -20px 16px; }
.fs-deck .c-green { background:var(--pm-green); } .fs-deck .c-red { background:var(--pm-red); }
.fs-deck .c-yellow { background:var(--accent-soft); } .fs-deck .c-blue { background:var(--accent); }
.fs-deck .stat .num { font-size:clamp(1.6rem,2.8vw,2.3rem); font-weight:800; letter-spacing:-.02em; line-height:1; }
.fs-deck .stat .lab { display:block; font-size:.86rem; color:var(--text-dim); margin-top:8px; }
.fs-deck .stat .sub { display:block; font-size:.76rem; color:var(--muted-2); margin-top:3px; }
.fs-deck .callout { border-left:4px solid var(--pm-yellow); background:color-mix(in srgb,var(--pm-yellow) 12%,var(--surface)); padding:16px 20px; border-radius:0 10px 10px 0; font-size:.95rem; }
.fs-deck .callout b { color:var(--text); }
.fs-deck .pill { display:inline-flex; align-items:center; gap:6px; font-size:.72rem; font-weight:700; padding:4px 10px; border-radius:999px; border:1px solid var(--border); color:var(--text-dim); }
.fs-deck .note { font-size:.78rem; color:var(--muted-2); margin-top:16px; line-height:1.5; }
.fs-deck .toolbar { position:sticky; top:0; z-index:20; display:flex; justify-content:flex-end; padding:12px clamp(20px,4vw,48px); background:color-mix(in srgb,var(--bg) 88%,transparent); backdrop-filter:blur(8px); border-bottom:1px solid var(--border); }
.fs-deck .btn { display:inline-flex; align-items:center; gap:8px; font-size:.82rem; font-weight:700; padding:8px 14px; border-radius:9px; border:1px solid var(--border); background:var(--surface); color:var(--text); cursor:pointer; }
.fs-deck .btn:hover { border-color:var(--accent); color:var(--accent); }
/* Diverging deviation-from-100 bar */
.fs-deck .dev { display:flex; flex-direction:column; gap:7px; margin-top:6px; }
.fs-deck .dev-row { display:grid; grid-template-columns:58px 1fr 40px; gap:12px; align-items:center; }
.fs-deck .dev-track { position:relative; height:20px; background:var(--surface-2); border-radius:5px; }
.fs-deck .dev-track::before { content:""; position:absolute; left:50%; top:-4px; bottom:-4px; width:2px; background:var(--muted-2); opacity:.55; }
.fs-deck .dev-fill { position:absolute; top:2px; bottom:2px; border-radius:3px; }
.fs-deck .dev-row .mon { font-size:.84rem; font-weight:600; color:var(--text-dim); }
.fs-deck .dev-row .val { font-family:var(--f-mono); font-size:.8rem; font-weight:700; text-align:right; font-variant-numeric:tabular-nums; color:var(--text); }
.fs-deck .dev-row.pk .mon, .fs-deck .dev-row.pk .val { color:var(--accent-strong); }
.fs-deck .dev-row.tr .mon, .fs-deck .dev-row.tr .val { color:var(--muted); }
.fs-deck .dev-cap { display:flex; justify-content:space-between; font-size:.72rem; color:var(--muted-2); font-family:var(--f-mono); margin:2px 58px 0 58px; }
.fs-deck .legend { display:flex; gap:18px; flex-wrap:wrap; font-size:.8rem; color:var(--text-dim); margin-top:14px; }
.fs-deck .legend i { display:inline-block; width:12px; height:12px; border-radius:3px; margin-right:6px; vertical-align:middle; }
/* Tablolar */
.fs-deck .tbl-wrap { overflow-x:auto; }
.fs-deck table.rep { width:100%; border-collapse:collapse; min-width:520px; }
.fs-deck table.rep th, .fs-deck table.rep td { padding:9px 12px; text-align:left; font-size:.88rem; border-bottom:1px solid var(--border); vertical-align:top; }
.fs-deck table.rep th { font-size:.7rem; text-transform:uppercase; letter-spacing:.06em; color:var(--text-dim); font-weight:700; }
.fs-deck table.rep td.num { text-align:right; font-family:var(--f-mono); font-variant-numeric:tabular-nums; }
.fs-deck table.rep .mo { font-weight:700; white-space:nowrap; }
.fs-deck .tone { display:inline-block; width:9px; height:9px; border-radius:50%; margin-right:8px; vertical-align:middle; }
.fs-deck table.idx { width:100%; border-collapse:collapse; min-width:640px; font-variant-numeric:tabular-nums; }
.fs-deck table.idx th, .fs-deck table.idx td { padding:8px 8px; text-align:center; font-size:.8rem; border-bottom:1px solid var(--border); font-family:var(--f-mono); }
.fs-deck table.idx th:first-child, .fs-deck table.idx td:first-child { text-align:left; font-family:var(--f-sans); font-weight:700; white-space:nowrap; }
.fs-deck table.idx th { color:var(--text-dim); font-weight:700; }
.fs-deck table.mon { width:100%; border-collapse:collapse; min-width:940px; font-variant-numeric:tabular-nums; }
.fs-deck table.mon th, .fs-deck table.mon td { padding:7px 9px; text-align:right; font-size:.78rem; border-bottom:1px solid var(--border); white-space:nowrap; }
.fs-deck table.mon thead th { color:var(--text-dim); font-size:.68rem; text-transform:uppercase; letter-spacing:.04em; font-weight:700; }
.fs-deck table.mon td { font-family:var(--f-mono); color:var(--text-dim); }
.fs-deck table.mon th:first-child, .fs-deck table.mon td:first-child { text-align:left; font-family:var(--f-sans); font-weight:700; color:var(--text); position:sticky; left:0; background:var(--surface); z-index:1; }
.fs-deck table.mon td.pk { color:var(--accent-strong); font-weight:700; background:color-mix(in srgb,var(--accent) 8%,transparent); }
.fs-deck table.mon td.avg { color:var(--text); font-weight:700; border-left:2px solid var(--border); }
@media print {
  .fs-deck .toolbar { display:none; }
  .fs-deck .slide { break-inside:avoid; page-break-inside:avoid; }
  .fs-deck .tbl-wrap { overflow:visible; } .fs-deck table.rep, .fs-deck table.idx { min-width:0; }
}
`;

const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const SEAS = {
  all:  [109, 93, 96, 103, 98, 93, 101, 99, 106, 105, 96, 102],
  gym:  [108, 94, 96, 100, 96, 93, 101, 97, 110, 107, 98, 99],
  diet: [113, 90, 93, 113, 111, 91, 100, 104, 88, 96, 87, 115],
};
// Tüm kelimeler — yıl × ay × kelime GERÇEK aylık arama hacmi (Google bucketed).
// Sütun sırası KW_COLS ile birebir; satırlar [ay, ...18 değer]. Yıllar/aylar yeniden→eskiye.
const KW_COLS = [
  { t: 'spor salonu', s: 'spor salonu' }, { t: 'fitness', s: 'fitness' }, { t: 'pilates', s: 'pilates' },
  { t: 'diyetisyen', s: 'diyetisyen' }, { t: 'zayıflama', s: 'zayıflama' }, { t: 'yoga', s: 'yoga' },
  { t: 'diyet', s: 'diyet' }, { t: 'crossfit', s: 'crossfit' }, { t: 'en yakın spor salonu', s: 'en yakın s.s.' },
  { t: 'aletli pilates', s: 'aletli pilates' }, { t: 'kilo verme', s: 'kilo verme' }, { t: 'hızlı kilo verme', s: 'hızlı kilo v.' },
  { t: 'spor salonu fiyatları', s: 's.s. fiyatları' }, { t: 'egzersiz', s: 'egzersiz' }, { t: 'boks salonu', s: 'boks salonu' },
  { t: 'evde spor', s: 'evde spor' }, { t: 'spor salonu üyelik', s: 's.s. üyelik' }, { t: 'kişisel antrenör', s: 'kişisel antr.' },
];
const KW_YEARLY = [
  { y: 2026, rows: [
    [6, 201000, 90500, 90500, 33100, 14800, 18100, 8100, 14800, 9900, 6600, 4400, 4400, 5400, 4400, 6600, 2900, 210, 110],
    [5, 165000, 74000, 90500, 27100, 33100, 18100, 14800, 14800, 8100, 6600, 4400, 5400, 5400, 5400, 6600, 2900, 140, 110],
    [4, 201000, 90500, 135000, 40500, 74000, 22200, 12100, 18100, 12100, 9900, 4400, 5400, 6600, 6600, 9900, 3600, 170, 110],
    [3, 201000, 90500, 110000, 40500, 22200, 22200, 8100, 18100, 14800, 9900, 4400, 4400, 8100, 5400, 8100, 2900, 210, 110],
    [2, 165000, 74000, 110000, 33100, 27100, 18100, 9900, 14800, 8100, 8100, 3600, 2900, 4400, 5400, 5400, 2900, 170, 110],
    [1, 201000, 74000, 110000, 33100, 60500, 22200, 12100, 14800, 9900, 8100, 3600, 4400, 5400, 5400, 5400, 3600, 210, 140],
  ] },
  { y: 2025, rows: [
    [12, 165000, 74000, 110000, 33100, 60500, 18100, 40500, 14800, 8100, 8100, 8100, 4400, 5400, 6600, 5400, 2400, 170, 110],
    [11, 165000, 74000, 110000, 33100, 27100, 22200, 12100, 22200, 9900, 8100, 3600, 4400, 5400, 8100, 5400, 1900, 140, 90],
    [10, 201000, 90500, 110000, 33100, 49500, 18100, 18100, 18100, 9900, 8100, 4400, 5400, 5400, 8100, 5400, 1600, 210, 170],
    [9, 201000, 90500, 90500, 33100, 40500, 18100, 22200, 18100, 9900, 8100, 3600, 5400, 6600, 5400, 4400, 1300, 170, 140],
    [8, 201000, 90500, 74000, 33100, 49500, 18100, 22200, 18100, 9900, 6600, 5400, 6600, 6600, 2900, 3600, 1600, 170, 170],
    [7, 201000, 90500, 74000, 33100, 27100, 18100, 33100, 18100, 12100, 6600, 8100, 6600, 8100, 3600, 4400, 1900, 140, 210],
    [6, 165000, 90500, 60500, 33100, 40500, 18100, 18100, 18100, 9900, 6600, 5400, 6600, 8100, 3600, 3600, 1600, 140, 170],
    [5, 165000, 90500, 90500, 40500, 27100, 18100, 22200, 18100, 8100, 8100, 6600, 9900, 8100, 6600, 3600, 2400, 140, 170],
    [4, 201000, 90500, 90500, 40500, 27100, 18100, 27100, 18100, 9900, 9900, 6600, 9900, 8100, 8100, 4400, 2400, 140, 140],
    [3, 165000, 74000, 90500, 33100, 22200, 18100, 40500, 12100, 6600, 8100, 5400, 8100, 8100, 5400, 4400, 1900, 140, 170],
    [2, 165000, 90500, 90500, 40500, 27100, 22200, 33100, 12100, 8100, 9900, 5400, 6600, 6600, 6600, 4400, 1900, 140, 170],
    [1, 246000, 135000, 135000, 49500, 40500, 27100, 27100, 14800, 9900, 12100, 8100, 9900, 8100, 5400, 6600, 2400, 170, 210],
  ] },
  { y: 2024, rows: [
    [12, 246000, 135000, 135000, 49500, 40500, 27100, 22200, 14800, 9900, 12100, 6600, 9900, 6600, 8100, 9900, 2400, 210, 260],
    [11, 246000, 135000, 110000, 40500, 33100, 27100, 18100, 14800, 9900, 9900, 6600, 8100, 6600, 6600, 12100, 1900, 140, 210],
    [10, 301000, 135000, 110000, 40500, 27100, 27100, 33100, 14800, 12100, 12100, 6600, 8100, 6600, 8100, 9900, 1900, 170, 210],
    [9, 368000, 165000, 110000, 40500, 27100, 27100, 12100, 14800, 12100, 12100, 8100, 8100, 8100, 6600, 8100, 1900, 170, 170],
    [8, 301000, 135000, 90500, 40500, 49500, 22200, 33100, 18100, 12100, 12100, 9900, 9900, 8100, 3600, 6600, 2400, 170, 170],
    [7, 301000, 165000, 90500, 49500, 33100, 22200, 22200, 18100, 14800, 12100, 12100, 12100, 9900, 4400, 8100, 2900, 170, 210],
    [6, 246000, 110000, 60500, 40500, 27100, 22200, 14800, 14800, 12100, 8100, 9900, 12100, 9900, 4400, 6600, 2400, 170, 170],
    [5, 246000, 110000, 90500, 49500, 18100, 27100, 18100, 18100, 12100, 14800, 12100, 14800, 9900, 8100, 12100, 2900, 140, 170],
    [4, 246000, 110000, 74000, 40500, 12100, 22200, 14800, 14800, 14800, 12100, 12100, 14800, 12100, 6600, 8100, 2900, 140, 170],
    [3, 246000, 110000, 74000, 40500, 9900, 22200, 12100, 14800, 14800, 12100, 9900, 9900, 12100, 6600, 8100, 2900, 170, 170],
    [2, 246000, 110000, 90500, 40500, 12100, 27100, 14800, 14800, 14800, 14800, 12100, 12100, 14800, 6600, 6600, 3600, 210, 170],
    [1, 246000, 110000, 90500, 40500, 12100, 27100, 14800, 14800, 14800, 14800, 14800, 12100, 14800, 6600, 6600, 3600, 170, 210],
  ] },
  { y: 2023, rows: [
    [12, 201000, 90500, 74000, 33100, 12100, 22200, 14800, 12100, 14800, 12100, 12100, 9900, 12100, 8100, 6600, 2900, 170, 170],
    [11, 201000, 90500, 60500, 27100, 9900, 22200, 12100, 12100, 14800, 9900, 9900, 8100, 9900, 8100, 6600, 2900, 170, 140],
    [10, 201000, 90500, 60500, 27100, 9900, 22200, 12100, 14800, 14800, 12100, 9900, 9900, 9900, 8100, 8100, 2400, 170, 170],
    [9, 201000, 90500, 49500, 27100, 9900, 22200, 9900, 14800, 12100, 12100, 9900, 9900, 9900, 6600, 8100, 2900, 170, 260],
    [8, 165000, 90500, 49500, 27100, 12100, 22200, 12100, 14800, 12100, 9900, 12100, 12100, 12100, 4400, 4400, 2900, 170, 170],
    [7, 201000, 90500, 49500, 27100, 12100, 22200, 14800, 14800, 12100, 9900, 14800, 12100, 12100, 4400, 4400, 3600, 210, 170],
    [6, 165000, 74000, 40500, 27100, 12100, 18100, 12100, 14800, 9900, 9900, 14800, 12100, 9900, 5400, 3600, 2900, 210, 170],
    [5, 165000, 74000, 49500, 33100, 27100, 22200, 27100, 14800, 9900, 12100, 18100, 14800, 9900, 6600, 3600, 2900, 170, 170],
    [4, 135000, 74000, 40500, 27100, 18100, 22200, 18100, 14800, 8100, 9900, 14800, 12100, 8100, 5400, 2900, 2400, 170, 170],
    [3, 135000, 74000, 49500, 27100, 14800, 22200, 14800, 18100, 6600, 12100, 14800, 12100, 8100, 5400, 2400, 3600, 210, 260],
    [2, 135000, 74000, 40500, 18100, 9900, 18100, 12100, 18100, 6600, 8100, 12100, 9900, 8100, 3600, 2400, 2900, 210, 170],
    [1, 135000, 74000, 60500, 27100, 22200, 22200, 18100, 18100, 6600, 12100, 14800, 12100, 12100, 5400, 2900, 2900, 210, 210],
  ] },
  { y: 2022, rows: [
    [12, 135000, 74000, 40500, 27100, 14800, 22200, 14800, 14800, 6600, 9900, 12100, 12100, 9900, 6600, 2400, 2900, 170, 170],
    [11, 135000, 74000, 40500, 22200, 9900, 22200, 12100, 14800, 6600, 9900, 12100, 12100, 9900, 6600, 2900, 2900, 170, 170],
    [10, 165000, 90500, 40500, 22200, 9900, 22200, 12100, 18100, 8100, 12100, 12100, 9900, 9900, 6600, 2900, 2400, 210, 210],
    [9, 165000, 90500, 40500, 22200, 9900, 22200, 9900, 22200, 8100, 9900, 12100, 9900, 9900, 8100, 2400, 2400, 170, 170],
    [8, 135000, 74000, 33100, 22200, 12100, 22200, 12100, 18100, 8100, 9900, 14800, 14800, 9900, 3600, 2400, 2900, 210, 320],
    [7, 135000, 74000, 27100, 22200, 9900, 22200, 12100, 18100, 6600, 8100, 14800, 12100, 9900, 3600, 1900, 2900, 140, 170],
  ] },
];

const SCALE = 2.5; // 1 endeks puanı = %2.5 track (maks ~15 puan → ~%37)

// Sapan (diverging) yatay bar: 100 merkez; >100 posColor (yüksek sezon), <100 nötr gri.
function DevChart({ data, posColor }) {
  const peak = Math.max(...data);
  const trough = Math.min(...data);
  return (
    <div className="dev">
      {data.map((idx, i) => {
        const up = idx >= 100;
        const w = Math.abs(idx - 100) * SCALE;
        const cls = idx === peak ? 'pk' : idx === trough ? 'tr' : '';
        const fill = up
          ? { left: '50%', width: `${w}%`, background: posColor }
          : { right: '50%', width: `${w}%`, background: 'var(--muted-2)' };
        return (
          <div className={`dev-row ${cls}`} key={i}>
            <span className="mon">{MONTHS[i].slice(0, 3)}</span>
            <div className="dev-track"><div className="dev-fill" style={fill} /></div>
            <span className="val">{idx}</span>
          </div>
        );
      })}
    </div>
  );
}

const TERMS = [
  { t: 'spor salonu', v: 198417, pk: 'Eylül', pkv: 118, tr: 'Şubat', trv: 90, note: 'Rutine/okula dönüş zirvesi' },
  { t: 'fitness', v: 95177, pk: 'Eylül', pkv: 115, tr: 'Şubat', trv: 92, note: 'Eylül + Ekim ağırlıklı' },
  { t: 'pilates', v: 78015, pk: 'Ocak', pkv: 127, tr: 'Temmuz', trv: 77, note: 'Kış temposu, yaz ölü' },
  { t: 'zayıflama', v: 25185, pk: 'Ocak', pkv: 122, tr: 'Kasım', trv: 84, note: 'Yeni yıl + yaz öncesi' },
  { t: 'diyet', v: 17975, pk: 'Aralık', pkv: 128, tr: 'Haziran', trv: 74, note: 'Yeni yıl + Temmuz plaj' },
  { t: 'crossfit', v: 16121, pk: 'Eylül', pkv: 108, tr: 'Aralık', trv: 88, note: 'Sonbahar ağırlıklı' },
  { t: 'kilo verme', v: 9425, pk: 'Temmuz', pkv: 132, tr: 'Kasım', trv: 85, note: 'Plaj paniği (yaz)' },
];

const CAL = [
  { m: 'Ocak', tone: 'peak', focus: 'Üyelik atağı', note: 'Yeni yıl kararları — akquisition + diyet talebi birlikte tavan. Yıllık paket sat.' },
  { m: 'Şubat', tone: 'low', focus: 'En zayıf ay', note: 'Dip. Retargeting + agresif teklif; iptal/kayıp önleme.' },
  { m: 'Mart', tone: 'mid', focus: 'Toparlanma', note: 'Ramazan bazı yıllar buraya denk gelir → esnek saat / online seçenek.' },
  { m: 'Nisan', tone: 'peak', focus: 'Yaz-öncesi diyet', note: '"Yaz vücudu" / kilo verme mesajını yükselt.' },
  { m: 'Mayıs', tone: 'peak', focus: 'Yaz-öncesi zirve', note: 'Diyet/zayıflama kreatifi + kısa vadeli üyelik.' },
  { m: 'Haziran', tone: 'low', focus: 'Gym dip → tutundurma', note: 'Gym araması düşer; win-back, yaz üyeliği, "arkadaş getir".' },
  { m: 'Temmuz', tone: 'mid', focus: 'Plaj paniği', note: '"kilo verme" zirvesi — kısa program + PT/diyet upsell.' },
  { m: 'Ağustos', tone: 'mid', focus: 'Hazırlık', note: 'Sakin; Eylül kampanyası + erken-kayıt indirimi kur.' },
  { m: 'Eylül', tone: 'peak', focus: 'EN BÜYÜK pencere', note: 'Rutine dönüş — üyelik bütçesinin zirvesi burada.' },
  { m: 'Ekim', tone: 'peak', focus: 'Güçlü devam', note: 'Yıllık paket + üyelik ivmesi sürer.' },
  { m: 'Kasım', tone: 'low', focus: 'Zayıflıyor → fırsat', note: 'Black Friday yıllık üyelik fırsatıyla canlandır.' },
  { m: 'Aralık', tone: 'peak', focus: 'Diyet zirvesi + hediye', note: 'Yeni-yıl öncesi diyet tavan; hediye üyelik; Ocak\'a hazırlık.' },
];
const TONE = { peak: 'var(--pm-green)', low: 'var(--pm-red)', mid: 'var(--pm-yellow)' };
const fmtTR = (n) => n.toLocaleString('tr-TR');

export default function FitnessSeasonality() {
  return (
    <div className="fs-deck">
      <style>{CSS}</style>

      <div className="toolbar">
        <button className="btn" onClick={() => window.print()}><Printer size={15} /> PDF / Yazdır</button>
      </div>

      {/* ===== COVER ===== */}
      <section className="slide cover">
        <div className="wrap">
          <div className="cover-top">
            <div className="logo-lockup">
              <span className="brick" aria-hidden="true">
                <i style={{ background: 'var(--accent)' }} /><i style={{ background: 'color-mix(in srgb,var(--accent) 55%,transparent)' }} /><i style={{ background: 'color-mix(in srgb,var(--accent) 30%,transparent)' }} />
                <i style={{ background: 'color-mix(in srgb,var(--accent) 55%,transparent)' }} /><i style={{ background: 'var(--accent)' }} /><i style={{ background: 'color-mix(in srgb,var(--accent) 55%,transparent)' }} />
                <i style={{ background: 'color-mix(in srgb,var(--accent) 30%,transparent)' }} /><i style={{ background: 'color-mix(in srgb,var(--accent) 55%,transparent)' }} /><i style={{ background: 'var(--accent)' }} />
              </span>
              Glowytics
            </div>
            <div className="pill">Sektör Analizi · Statik Rapor</div>
          </div>

          <span className="eyebrow"><span className="dot" />Fitness & Spor Salonu · Türkiye</span>
          <h1>Arama <span className="hl">mevsimselliği</span>:<br />yılın hangi ayı ne satılır?</h1>
          <p className="cover-sub">Türkiye'de fitness/spor salonu talebinin aydan aya nasıl dalgalandığını Google arama hacimlerinden çıkardık — üyelik bütçesini doğru aya koymak için.</p>
          <div className="rule" />
          <div className="cover-meta">
            <div><span className="k">Veri</span><span className="v">Google Keyword Planner</span></div>
            <div><span className="k">Kapsam</span><span className="v">Türkiye · 48 ay (2022–2026)</span></div>
            <div><span className="k">Yöntem</span><span className="v">Takvim-ayı endeksi (100=ort.)</span></div>
            <div><span className="k">Tarih</span><span className="v">Temmuz 2026 · Glowytics</span></div>
          </div>
        </div>
      </section>

      {/* ===== ÖZET ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Özet</span>
            <h2>İki büyük üyelik penceresi:<br />Eylül ve Ocak.</h2>
            <p className="lead">Talep tek bir eğri değil — <b>gym/üyelik</b> niyeti ile <b>kilo/diyet</b> niyeti farklı aylarda zirve yapıyor. Bütçe ve mesaj bu iki ritme göre kurulmalı.</p>
          </div>
          <div className="grid g4">
            <div className="card"><div className="topbar c-green" /><div className="stat"><span className="num">Eylül</span><span className="lab">Gym/üyelik zirvesi (endeks 110)</span><span className="sub">Rutine/okula dönüş — en büyük pencere</span></div></div>
            <div className="card"><div className="topbar c-blue" /><div className="stat"><span className="num">Ocak</span><span className="lab">İkinci büyük pencere (109)</span><span className="sub">Yeni yıl kararları</span></div></div>
            <div className="card"><div className="topbar c-yellow" /><div className="stat"><span className="num">Nis–May</span><span className="lab">Diyet/"yaz vücudu" zirvesi</span><span className="sub">Kilo verme motivasyonu tavan</span></div></div>
            <div className="card"><div className="topbar c-red" /><div className="stat"><span className="num">Şub · Haz</span><span className="lab">En zayıf aylar</span><span className="sub">Tutundurma & agresif teklif dönemi</span></div></div>
          </div>
        </div>
      </section>

      {/* ===== TOPLAM EĞRİ ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Toplam Fitness Talebi · Yıllık Eğri</span>
            <h2>Aydan aya arama endeksi.</h2>
            <p className="lead">Merkez çizgi = yıllık ortalama (100). Sağa (indigo) = ortalamanın üzerinde / yüksek sezon; sola (gri) = altında / durgun. ~18 terimlik sepet, hacimle ağırlıklandırıldı.</p>
          </div>
          <div className="card">
            <div className="dev-cap"><span>◀ durgun</span><span>100 = yıl ort.</span><span>yüksek sezon ▶</span></div>
            <DevChart data={SEAS.all} posColor="var(--accent)" />
          </div>
        </div>
      </section>

      {/* ===== İKİ RİTİM ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />İki Ayrı Ritim</span>
            <h2>Gym üyeliği başka, diyet başka aylarda patlar.</h2>
            <p className="lead">Aynı sepetin içindeki iki niyet farklı takvimlere sahip: gym/üyelik <b>Eylül + Ocak</b>'ta; kilo/diyet <b>Aralık–Ocak + Nisan–Mayıs</b>'ta. Diyet tarafı daha oynak (amplitüd ~28 vs ~17 puan).</p>
          </div>
          <div className="grid g2">
            <div className="card">
              <div className="topbar c-blue" />
              <h3 style={{ marginBottom: 4 }}>🏋️ Gym / üyelik niyeti</h3>
              <p style={{ color: 'var(--text-dim)', fontSize: '.85rem', marginBottom: 10 }}>spor salonu · fitness · pilates · crossfit · fiyat · "en yakın"</p>
              <DevChart data={SEAS.gym} posColor="var(--accent)" />
            </div>
            <div className="card">
              <div className="topbar" style={{ background: 'var(--teal)' }} />
              <h3 style={{ marginBottom: 4 }}>⚖️ Kilo / diyet niyeti</h3>
              <p style={{ color: 'var(--text-dim)', fontSize: '.85rem', marginBottom: 10 }}>kilo verme · diyet · zayıflama · diyetisyen · egzersiz</p>
              <DevChart data={SEAS.diet} posColor="var(--teal)" />
            </div>
          </div>
          <div className="legend">
            <span><i style={{ background: 'var(--accent)' }} />Gym (yüksek sezon)</span>
            <span><i style={{ background: 'var(--teal)' }} />Diyet (yüksek sezon)</span>
            <span><i style={{ background: 'var(--muted-2)' }} />Ortalama altı / durgun</span>
          </div>
        </div>
      </section>

      {/* ===== AKSİYON TAKVİMİ ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Aksiyon Takvimi</span>
            <h2>Hangi ay ne yapmalı?</h2>
            <p className="lead">Spor salonu için ay ay öncelik: bütçeyi zirvelere yığ, dipte tutundur.</p>
          </div>
          <div className="card tbl-wrap">
            <table className="rep">
              <thead><tr><th>Ay</th><th>Odak</th><th>Ne yapmalı</th></tr></thead>
              <tbody>
                {CAL.map((c) => (
                  <tr key={c.m}>
                    <td className="mo"><span className="tone" style={{ background: TONE[c.tone] }} />{c.m}</td>
                    <td style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{c.focus}</td>
                    <td style={{ color: 'var(--text-dim)' }}>{c.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="legend">
            <span><i style={{ background: 'var(--pm-green)', borderRadius: '50%' }} />Yüksek sezon — akquisition</span>
            <span><i style={{ background: 'var(--pm-yellow)', borderRadius: '50%' }} />Orta / geçiş</span>
            <span><i style={{ background: 'var(--pm-red)', borderRadius: '50%' }} />Dip — tutundurma & teklif</span>
          </div>
        </div>
      </section>

      {/* ===== TEKİL TERİMLER ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Tekil Terim Örüntüleri</span>
            <h2>Her aramanın kendi mevsimi var.</h2>
            <p className="lead">Ortalamanın altında gizlenen sivri desenler — hizmet/kreatif planını buna göre kur (ör. pilates kışın, "kilo verme" yazın).</p>
          </div>
          <div className="card tbl-wrap">
            <table className="rep">
              <thead><tr><th>Terim</th><th className="num">Aylık ort. arama</th><th>Zirve</th><th>Dip</th><th>Örüntü</th></tr></thead>
              <tbody>
                {TERMS.map((t) => (
                  <tr key={t.t}>
                    <td style={{ fontWeight: 700 }}>{t.t}</td>
                    <td className="num">{fmtTR(t.v)}</td>
                    <td style={{ color: 'var(--accent-strong)', fontWeight: 700, whiteSpace: 'nowrap' }}>{t.pk} <span style={{ fontFamily: 'var(--f-mono)', fontWeight: 400 }}>({t.pkv})</span></td>
                    <td style={{ color: 'var(--muted)', whiteSpace: 'nowrap' }}>{t.tr} <span style={{ fontFamily: 'var(--f-mono)' }}>({t.trv})</span></td>
                    <td style={{ color: 'var(--text-dim)' }}>{t.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="callout" style={{ marginTop: 18 }}>
            <b>Çıkarım →</b> Pilates/yoga <b>kış</b> ürünü (Ocak zirve, yaz dip); "kilo verme"/diyet <b>yaz-öncesi + yeni yıl</b> ürünü; gym üyeliği <b>Eylül + Ocak</b>. Tek bir "yaz kampanyası"na sıkışma — talebin şekli hizmete göre değişiyor.
          </div>
        </div>
      </section>

      {/* ===== VERİ TABLOSU + YÖNTEM ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Veri Tablosu & Yöntem</span>
            <h2>Endeks değerleri (100 = yıl ort.).</h2>
          </div>
          <div className="card tbl-wrap">
            <table className="idx">
              <thead><tr><th>Küme</th>{MONTHS.map((m) => <th key={m}>{m.slice(0, 3)}</th>)}</tr></thead>
              <tbody>
                <tr><td>Toplam</td>{SEAS.all.map((v, i) => <td key={i}>{v}</td>)}</tr>
                <tr><td>Gym</td>{SEAS.gym.map((v, i) => <td key={i}>{v}</td>)}</tr>
                <tr><td>Diyet</td>{SEAS.diet.map((v, i) => <td key={i}>{v}</td>)}</tr>
              </tbody>
            </table>
          </div>
          <p className="note">Kaynak: Google Ads Keyword Planner (KeywordPlanIdeaService · GenerateKeywordHistoricalMetrics), yalnızca GOOGLE_SEARCH ağı. Coğrafi hedef Türkiye (geo 2792), dil Türkçe (1037). Dönem: Temmuz 2022 – Haziran 2026 (48 ay); her takvim ayı 4 yıl ortalamasıyla hesaplanıp yıllık ortalamaya endekslendi (100 = ortalama ay). Sepet ~18 jenerik terim (spor salonu, fitness, pilates, aletli pilates, spor salonu fiyatları, en yakın spor salonu, crossfit, yoga, boks salonu, kilo verme, hızlı kilo verme, diyet, diyetisyen, zayıflama, evde spor, egzersiz…); marka/tesis isimleri (macfit, atatürk spor salonu vb.) elendi. Kompozit endeks hacimle ağırlıklandırıldı. Değerler Google'ın basamaklı (bucketed) tahminleridir; yön göstergesidir. ⚠️ Ramazan yıllara göre kayar (2022–26'da Şubat–Nisan) → takvim-ayı ortalaması bu etkiyi kısmen yumuşatır; Şubat dipinde payı olabilir.</p>
        </div>
      </section>

      {/* ===== TÜM KELİMELER · AY-AY HAM RAKAM ===== */}
      <section className="slide">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow"><span className="dot" />Tüm Kelimeler · Yıl / Ay Gerçek Rakam</span>
            <h2>Her kelimenin, her yılın, her ayı.</h2>
            <p className="lead">Endeks değil, <b>gerçek aylık arama hacmi</b>. Üstte kelimeler, solda aylar; her yıl kendi başlığıyla (2026 dahil, aylar yeniden→eskiye). Her satırda <b>o ayın en çok arananı</b> vurgulu.</p>
          </div>
          {KW_YEARLY.map((yr) => {
            // Her kelime (sütun) için o yılın zirve ayını vurgula → mevsimsellik satır bazında okunur.
            const colMax = KW_COLS.map((_, i) => Math.max(...yr.rows.map((row) => row[i + 1])));
            return (
              <div key={yr.y} style={{ marginBottom: 22 }}>
                <h3 style={{ margin: '4px 0 10px', fontFamily: 'var(--f-mono)', letterSpacing: '.05em' }}>{yr.y}</h3>
                <div className="card tbl-wrap" style={{ padding: 0 }}>
                  <table className="mon">
                    <thead>
                      <tr><th>Ay</th>{KW_COLS.map((k) => <th key={k.t} title={k.t}>{k.s}</th>)}</tr>
                    </thead>
                    <tbody>
                      {yr.rows.map((row) => (
                        <tr key={row[0]}>
                          <td>{MONTHS[row[0] - 1].slice(0, 3)}</td>
                          {row.slice(1).map((v, i) => <td key={i} className={v === colMax[i] ? 'pk' : undefined}>{fmtTR(v)}</td>)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
          <p className="note">Kaynak: Google Ads Keyword Planner, Türkiye (geo 2792) · Türkçe (1037), GOOGLE_SEARCH. Değerler o yıl-ay için Google'ın raporladığı gerçek aylık arama hacmidir (basamaklı/bucketed tahmin). Vurgulu hücre = o ayın (satırın) en çok aranan kelimesi. 2026 yalnızca Oca–Haz, 2022 yalnızca Tem–Ara (veri penceresi 48 ay). "s.s. üyelik" ve "kişisel antrenör" tam-öbek olarak düşük bucket'lanır (talep eş anlamlılara dağılır).</p>
        </div>
      </section>

      <section className="slide" style={{ borderBottom: 'none', paddingTop: '34px' }}>
        <div className="wrap">
          <div className="rule" style={{ marginBottom: 20 }} />
          <p style={{ color: 'var(--text-dim)', fontSize: '.85rem' }}><strong>Fitness Sektörü · Türkiye Arama Mevsimselliği</strong> · Hazırlayan: Glowytics · Temmuz 2026 · <span style={{ color: 'var(--muted-2)' }}>Statik analiz — Google arama hacmi verisine dayanır.</span></p>
        </div>
      </section>
    </div>
  );
}
